import React, { useReducer, useEffect } from "react";
import useSWR from "swr";

import SchemaReviewsWrapper from "../../components/SchemaReviewsWrapper";
import HeaderContent from "./HeaderContent";
import "./Header.scss";

export const reducer = (state, action) => {
  switch (action.type) {
    case "LOADED_DATA": {
      const settings = {
        ratingLimit: parseFloat((action.settings && action.settings.ratingLimit) || "4.0"),
      };
      const { averageRating } = action.payload;
      const showSchema = (averageRating >= settings.ratingLimit);

      return {
        merchant: action.payload,
        reviews: state.reviews,
        error: false,
        showSchema
      };
    }
    case "LOADED_REVIEWS": {
      return {
        ...state,
        reviews: action.payload
      };
    }
    case "DATA_ERROR":
      return { merchant: null, reviews: [], error: true, showSchema: false };
    default:
      return state;
  }
};

export const defaultState = {
  merchant: null,
  reviews: [],
  error: false,
  showSchema: false
};
export const HeaderContext = React.createContext(defaultState);

const Header = (props) => {
  const fetcher = (...args) => fetch(...args).then((r) => r.json());
  const { data } = useSWR(
    `${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${props.merchant}.json?widget=header`,
    fetcher,
    { revalidateOnFocus: false }
  );

  const [state, dispatch] = useReducer(reducer, defaultState);
  const { randomize, thirdParty, homePage } = props;

  const { data: reviewsData } = useSWR(
    props && props.merchant && homePage ?
    `${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${props.merchant}/reviews.json?limit=${2}&page=${1}&thirdParty=${thirdParty}&randomize=${randomize}&currentLocationReviewsOnly=${false}` :
    null,
    fetcher,
    {
      revalidateOnFocus: false,
      onSuccess: (data) => {
        if (data && data.reviews) {
          dispatch({ type: "LOADED_REVIEWS", payload: data.reviews });
        }
      }
    }
  );

  useEffect(() => {
    if (data && data.merchant) {
      dispatch({
        type: "LOADED_DATA",
        payload: data.merchant,
        settings: props
      });
    }
  }, [data, props]);

  if (!data || !data.merchant) {
    return null;
  }

  return (
    <HeaderContext.Provider value={{ state, dispatch }}>
      {state.showSchema && <SchemaReviewsWrapper merchant={data.merchant} reviews={state.reviews} />}
      <HeaderContent
        merchant={data.merchant}
        props={props}
      />
    </HeaderContext.Provider>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/containers/Header/index.jsx